import { AlertTriangle, Clock } from 'lucide-react';
import logo from '../../assets/images/Logo for website/Desktop.png';

const MaintenancePage = ({ message, estimatedTime }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center">
      <img src={logo} alt="Logo" className="h-auto w-auto" />
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
          
          <AlertTriangle className="h-8 w-8 text-yellow-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-4">Under Maintenance</h1>
        <p className="text-gray-600 mb-6">{message}</p>
        
        <div className="flex items-center justify-center text-gray-500">
          <Clock className="h-5 w-5 mr-2" />
          <span>Estimated downtime: {estimatedTime}</span>
        </div>
        
        <div className="mt-8 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            We apologize for the inconvenience. Please check back later.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;